import { render } from "./SelectMultiField.vue?vue&type=template&id=24dbf0a9"
import script from "./SelectMultiField.vue?vue&type=script&lang=js"
export * from "./SelectMultiField.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__